function SkeletonFooter() {
	return (
		<footer className="-inset-x-0 bg-slate-300">
			<div className="container flex justify-between items-center mx-auto px-2 py-1 md:grid md:grid-cols-header md:py-4 xl:px-0 max-w-6xl xl:max-w-5xl 2xl:max-w-screen-lg"></div>
		</footer>
	);
}

export default SkeletonFooter;
